import "./fht1Advertisements";
import "./productList.scss";
import "./recommendedProducts.scss";
import { Slick } from "@/pages/vendors/vendor.slick";
$(function () {
  new Slick($(".mobile-products-container__content"), {
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4
  });
  var $cNames = $(".product-card__company-name > a");
  $cNames.each(function (idx, el) {
    var $el = $(el);
    var $icons = $el.parent().next();

    if ($icons.children().length === 0) {
      $el.css({
        "max-width": "188px"
      });
    } else if ($icons.children().length === 1) {
      $el.css({
        "max-width": "160px"
      });
    } else if ($icons.children().length === 2) {
      $el.css({
        "max-width": "143px"
      });
    }

    var leftPos = $el.width() + "px";
    $icons.css({
      left: leftPos
    });
  });
});